export default (sessionKey: string) => localStorage.setItem('sessionKey', sessionKey)
